module.exports = {"top3":["Adults who went without care because of cost","Children who are overweight or obese","Drug poisoning deaths"],"bottom3":["Alcohol deaths","Children without a medical and dental preventive care visit","Adults without a usual source of care"],"most_improved":["Children who are overweight or obese","Colorectal cancer deaths","Home health patients without improved mobility"],"most_declined":["Children without all recommended vaccines","Preventable hospitalizations ages 18-64","Hospital 30-day mortality"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/ND.json
// module id = 268
// module chunks = 143196823979170 184088790168614